/* prettier-ignore */

import { Component, computed, inject, Input} from '@angular/core';
import { ModalController } from '@ionic/angular';
import { TranslateService } from '@ngx-translate/core';
import { ChatBotScriptService } from 'src/app/services/chatbot.service';
import { GoogleTranslateService } from 'src/app/services/google-translate.service';
import { ToolsService } from 'src/app/services/tools.service';
import { TranslationService } from 'src/app/services/translation.service';
import { SelectGoogleLanguageComponent } from 'src/app/shared/select-google-lang/select-google-lang.component';

@Component({
  selector: 'header-languages',
  templateUrl: './languages.component.html',
  styleUrl: './languages.component.scss',
})

export class HeaderLanguagesComponent {
    @Input('clientId') clientId: number = null;
    
    private _translationService = inject(TranslationService);
    
    public isTechMode = computed(() => this.tools.isTechMode())
    public isTechEditMode = computed(() => this.tools.isTechEditMode());
    public isRegisterMode = computed(() => this.tools.isRegisterMode());
    public languages = computed(() => this.tools.languages());
    public isWebApp = computed(() => this.tools.isWebApp());
    public headerLangType = computed(() => this.tools.headerLangType());
    public showGoogleLangs = computed(() => this.googleTranslateService.showGoogleLangs());

    constructor(
        public googleTranslateService: GoogleTranslateService,
        private chatService: ChatBotScriptService,
        private translate: TranslateService,
        private modalCtrl: ModalController,
        private tools: ToolsService
    ) {}

    changeLanguage(lang){
        const cookieLang = this.googleTranslateService.getCookieLang();
        if (cookieLang) this.googleTranslateService.deleteCookieLang();
        this.googleTranslateService.currentLang = lang;
        this.googleTranslateService.setLocalLang(lang);
        this.chatService.setLang(lang);
        this._translationService.setTranslateService(lang);
        this._translationService.selectedLanguage.set(lang);
    }

    async changeGoogleLanguage(){
        const modal = await this.modalCtrl.create({
            component: SelectGoogleLanguageComponent,
            cssClass: "langModal",
        });
        await modal.present();
    }

}